import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectAvailableLanguages, selectCurrenLang, selectShowButton } from 'store/intl/selectors'
import { switchLanguage } from 'store/intl/actions'

const mapStateToProps = (state) => ({
  currentLang: selectCurrenLang(state),
  availableLanguages: selectAvailableLanguages(state),
  showButton: selectShowButton(state),
});

const mapDispatchToProps = (dispatch) => (
  bindActionCreators({ switchLanguage }, dispatch)
);

const withIntl = () => connect(
  mapStateToProps,
  mapDispatchToProps,
)

export default withIntl



// WEBPACK FOOTER //
// ./src/store/intl/withIntl.js